import { fmt, pct, perAff, perPacked, RAMP, stateOf } from '../bamsShortsUtils';

// One card per facility/brand: the headline shorts-per-order rate, the per-affected
// figure, the distribution breakdown, and the change versus the prior week.
export function FacilityGauges({ curRolled, prvRolled }) {
    return (
        <div className="gauges">
            {curRolled.map((e) => {
                const pp = perPacked(e);
                const pa = perAff(e);
                const [lab, col] = stateOf(pp);
                const p = prvRolled && prvRolled.find((x) => x.brand === e.brand && x.facility === e.facility);
                const d = p && perPacked(p) ? ((pp - perPacked(p)) / perPacked(p)) * 100 : null;
                const noDataGauge = e.packed > 0 && e.short_ord === 0;
                const color = noDataGauge ? 'var(--faint)' : col;
                return (
                    <div className="gauge" key={`${e.brand}|${e.facility}`} style={{ borderTopColor: color }}>
                        <div className="row1">
                            <span className="fc">{e.facility}</span>
                            <span className="state" style={{ color }}>
                                {noDataGauge ? 'NO DATA' : lab}
                            </span>
                        </div>
                        <div className="heads">
                            <div>
                                <div className="big" style={{ color }}>
                                    {noDataGauge ? '—' : pp.toFixed(2)}
                                </div>
                                <div className="hlab">per order packed</div>
                            </div>
                            <div className="hsplit">
                                <div className="big two" style={{ color: 'var(--muted)' }}>
                                    {noDataGauge ? '—' : pa.toFixed(2)}
                                </div>
                                <div className="hlab">per affected</div>
                            </div>
                        </div>
                        <div className="biglab">{e.brand.replace(/_/g, ' ')} · shorts per order</div>
                        <dl>
                            <dt>Orders packed</dt>
                            <dd>{fmt(e.packed)}</dd>
                            <dt>Orders with a short</dt>
                            <dd>{noDataGauge ? '—' : pct(e.short_ord, e.packed)}</dd>
                            <dt>Missing 3+ items</dt>
                            <dd>{noDataGauge ? '—' : pct(e.o3, e.packed)}</dd>
                            <dt>Swap cards issued</dt>
                            <dd style={{ color: e.swapcards ? RAMP[1] : 'inherit' }}>
                                {noDataGauge ? '—' : pct(e.swapcards, e.packed)}
                            </dd>
                            {d !== null ? (
                                <>
                                    <dt style={{ fontWeight: 600, color: 'var(--ink)' }}>vs prior week</dt>
                                    <dd
                                        style={{
                                            fontWeight: 600,
                                            color: d > 3 ? RAMP[7] : d < -3 ? RAMP[0] : 'inherit',
                                        }}
                                    >
                                        {d >= 0 ? '+' : ''}
                                        {d.toFixed(0)}%
                                    </dd>
                                </>
                            ) : null}
                        </dl>
                    </div>
                );
            })}
        </div>
    );
}
